<!-- @format -->
<binding-tag>
    <slot/>
    <script>
        import debounce from 'debounce-promise';
        import di       from "dependeny-injection";
        import bankAccount    from "@model/bankAccount/api";

        export default {
            bankAccount: bankAccount,
            input: null,
            setBinding() {
                if((this.root.tagName === 'INPUT' && this.root.type === 'text') || this.root.tagName === 'TEXTAREA') {
                    this.root.value    = this.bankAccount.item[this.props.name]
                    this.root.onkeyup  = this.input
                    this.root.onchange = this.input
                    this.root.onpaste  = this.input
                    this.root.onblur   = this.input
                }
            },
            setValid(valid) {
                if (valid) {
                    this.root.classList.remove('is-error')
                    if (null !== this.root.parentElement) {
                        let errors = this.root.parentElement.getElementsByClassName('error')
                        for (let error of errors) {
                            this.root.parentElement.removeChild(error)
                        }
                    }
                } else {
                    if (null !== this.root.parentElement) {
                        if (!this.root.classList.contains('is-error')) {
                            this.root.classList.add('is-error')

                            const div = document.createElement('div')
                            div.textContent = this.props.errmsg
                            div.classList.add('error')
                            this.root.parentElement.appendChild(div)
                        }
                    }
                }
            },
            onMounted(props, state) {
                this.input = debounce((e)=> {
                    let value = e.target.value
                    let validation = this.bankAccount.getValidation(this.props.name)
                    let valid = this.bankAccount.item.set(this.props.name, value, validation)
                    this.bankAccount.trigger('set:' + this.props.name, value, valid)
                    this.setValid(valid)
                }, 100)

                this.bankAccount.on('setValid:' + this.props.name, (valid)=> this.setValid(valid))

                this.setBinding()
            },
            onUnmounted(props, state) {
                this.bankAccount.off('setValid:' + this.props.name, (valid)=> this.setValid(valid))
            },
            onUpdated(props, state) {
                if ((this.root.tagName === 'INPUT' && this.root.type === 'text') || 
                    this.root.tagName === 'TEXTAREA'
                ) {
                    this.root.value = this.bankAccount.item[this.props.name]
                }
            }
        }
    </script>
</binding-tag>